import billingModule from '../../billing.module';
import template from './billingModalAddPayment.component.html';
import style from './billingModalAddPayment.component.css';

export default billingModule.component('billingModalAddPayment', {
    template,
    style,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
    },
    controller(billingActionService, billingPaymentService) {
        var vm = this;

        vm.callback = (success, result) => {
            if (success && !result.close) {
                vm.dismiss({ $value: { close: true } });

                if (result.plan && result.product) {
                    billingActionService.openModalSelectPlan({
                        plan: result.plan,
                        product: result.product,
                        paymentMethod: {
                            id: result.paymentMethodId
                        }
                    });
                } else {
                    billingPaymentService.updateCurrentPaymentMethod(
                        result.paymentMethodId
                    );
                }
            }
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-add-payment/billingModalAddPayment.component.js